// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/fic-preflight-enroute-services.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/fic-preflight-enroute-services/fic-preflight-enroute-services.js';

mount([g0]);
